import { registerLocaleData } from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeFr from '@angular/common/locales/fr';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, withComponentInputBinding, withNavigationErrorHandler } from '@angular/router';

import { authInterceptor } from './shared/services/auth.interceptor';
import { localeInterceptor } from './shared/services/locale.interceptor';
import { routes } from './app.routes';

// Angular ne ship pas les données locales par défaut depuis v9. On enregistre
// `fr` puis on l'alias en `fr-SN` (le Sénégal n'a pas de pack distinct, on
// hérite du `fr` standard — formats date / nombres identiques pour le besoin).
registerLocaleData(localeFr, 'fr-SN');
// EN pour la bascule i18n : les dates suivent la langue via le pipe `| ldate`.
registerLocaleData(localeEn, 'en');

/**
 * Après un redéploiement, un onglet resté ouvert référence des chunks (`chunk-XXXX.js`) qui
 * n'existent plus : la navigation vers une page lazy échoue en « Failed to fetch dynamically
 * imported module » (recette 2026-10-24, formulaire véhicule). On recharge la page une fois
 * pour récupérer le nouvel index ; un garde-fou en sessionStorage évite toute boucle.
 */
function reloadOnStaleChunk(error: unknown): void {
  const message = String((error as { message?: string })?.message ?? error);
  if (!/dynamically imported module|Loading chunk|ChunkLoadError/i.test(message)) return;
  const key = 'nawam.chunk-reload';
  if (sessionStorage.getItem(key)) return;
  sessionStorage.setItem(key, String(Date.now()));
  window.location.reload();
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: 'fr-SN' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding(), withNavigationErrorHandler(reloadOnStaleChunk)),
    provideHttpClient(withInterceptors([localeInterceptor, authInterceptor])),
  ],
};
